import { Route } from '@angular/router';

import { SHIPPING_ROUTES } from './modules/shipping/shipping.routes';
import { STAND_BY_ROUTES } from './modules/stand-by/stand-by.routes';

export const ROUTES: Route[] = [
  {
    path: ':shippingReference',
    loadChildren: SHIPPING_ROUTES,
  },
  {
    path: '',
    loadChildren: STAND_BY_ROUTES,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
